'use client';

import React from 'react';

export type LoaderProps = {
  id?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  border?: string;
  style?: React.CSSProperties;
  ariaLabel?: string;
};

const px = (v: string | number | undefined) =>
  typeof v === 'number' ? `${v}px` : v;

const Loader: React.FC<LoaderProps> = ({
  id,
  className = '',
  width,
  height,
  border,
  style,
  ariaLabel = 'Loading',
}) => {
  const classes = `loader${className ? ` ${className}` : ''}`;

  const inlineStyle: React.CSSProperties = {
    // expose size/border to the ::after spinner via CSS custom properties
    // (pseudo-elements cannot be styled via inline styles directly)
    ...({ ['--loader-width']: px(width) ?? undefined } as React.CSSProperties),
    ...({
      ['--loader-height']: px(height) ?? undefined,
    } as React.CSSProperties),
    ...({ ['--loader-border']: border ?? undefined } as React.CSSProperties),
    ...style,
  };

  return (
    <div
      id={id}
      className={classes}
      style={inlineStyle}
      role='status'
      aria-live='polite'
      aria-label={ariaLabel}
    />
  );
};

export default Loader;
